export function importAll(resource) {
  resource.keys().forEach(resource)
}

